export const bonuses = [
  {
    label: 'Bono 1',
    title: '25 Escenarios de Simulación',
    body: 'Casos listos de RCP, DEA, atragantamiento, hemorragias y más, con checklist y debriefing.',
    highlight: 'Elegís → preparás → simulás',
  },
  {
    label: 'Bono 2',
    title: 'Pack Profesional de Evaluaciones',
    body: 'Banco de preguntas, claves de respuesta, rúbricas y checklists de habilidades.',
    highlight: 'Conocimiento + decisión + ejecución',
  },
  {
    label: 'Bono 3',
    title: '10 Clases Listas para Dictar',
    body: 'Planificaciones completas en formato express (60 min), taller (2 h) y jornada (6/8 h).',
    highlight: 'Abrís → adaptás → dictás',
  },
  {
    label: 'Bono 4',
    title: 'Kit Visual e Imprimible',
    body: 'Infografías, algoritmos, pósters, fichas de bolsillo y tarjetas de repaso.',
    highlight: 'Proyectar + imprimir + entregar',
  },
  {
    label: 'Bono 5',
    title: 'Pack de Gestión del Instructor',
    body: 'Checklists, asistencia, inventario, encuestas y modelos de constancias.',
    highlight: 'Antes → durante → después',
  },
];